module.exports = __webpack_public_path__ + "img/headBg.4a3d54bd.png";